import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { ArrowRight } from 'lucide-react';
import { productCategories } from '../../mockData';

export const CategorySection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Specialization</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Three core categories: Professional Salon Tools, Barbershop Essentials & Manicure/Pedicure Instruments
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {productCategories.map((category, index) => (
            <Link key={category.id} to={`/products?category=${category.id}`}>
              <Card className="group cursor-pointer hover:shadow-2xl transition-all duration-500 overflow-hidden border-0 transform hover:scale-105 hover:-translate-y-2">
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover group-hover:scale-125 transition-transform duration-700"
                  />
                  {/* Animated gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" />
                  
                  {/* Gold shimmer effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-yellow-500/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                  
                  {/* Sparkle decorations */}
                  <div className="absolute top-4 right-4 w-2 h-2 bg-yellow-400 rounded-full animate-pulse opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  <div className="absolute top-8 right-8 w-1 h-1 bg-yellow-300 rounded-full animate-pulse opacity-0 group-hover:opacity-100 transition-opacity" style={{animationDelay: '0.3s'}}></div>
                  
                  <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                    <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-yellow-300 transition-colors">{category.name}</h3>
                    <p className="text-gray-200 text-sm mb-4 line-clamp-2 group-hover:text-gray-100 transition-colors">{category.description}</p>
                    <Badge className="bg-gradient-to-r from-yellow-600 via-yellow-500 to-yellow-400 text-black border-0 font-semibold shadow-lg shadow-yellow-500/50 group-hover:shadow-yellow-500/80 transition-all">
                      {category.productCount}+ Products
                    </Badge>
                  </div>
                </div>
                <CardContent className="p-6 bg-gradient-to-br from-white to-gray-50">
                  <div className="flex items-center justify-between">
                    <span className="text-yellow-700 font-bold group-hover:text-yellow-600 transition-colors">
                      View Luxury Collection
                    </span>
                    <ArrowRight className="w-5 h-5 text-yellow-700 group-hover:translate-x-2 group-hover:text-yellow-600 transition-all duration-300" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
